import axios from 'axios';

export async function sendStripePayment({ type, cardDetails, planDetails, paymentMethodId, confirmPaymentIntentId }) {
    let variables = {
        cardDetails,
        planDetails,
        paymentMethodId
    };

    let URL;

    if (type === "servicePlanStripe") {
        URL = '/stripe-servicePlan';
    } else if (type === 'confirmServicePlanStripe') {
        URL = '/confirm-stripe-servicePlan';
        variables = {
            planDetails,
            confirmPaymentIntentId
        };
    }

    try {
        const { data } = await axios.post(URL, variables, {
            withCredentials: true,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });


        const { status, errorMessage, redirect, accountId, paymentIntentSecret } = data;

        if (status === 200 && redirect) {
            window.location = redirect;
        }

        return {
            status,
            errorMessage,
            accountId,
            paymentIntentSecret
        };

    } catch (error) {
        return {
            status: 400,
            errorMessage: error?.response?.data?.errorMessage || "Something went wrong"
        };
    }
}
